var _rect, _g, _rect2, _g2, _path, _path2, _path3, _rect3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvaluate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 25,
    viewBox: "0 0 45 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_307_4132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 8,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 8,
    height: 25,
    fill: "#FCCDB3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_307_4132)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23.8096,
    width: 21.4286,
    height: 4,
    rx: 2,
    transform: "rotate(-90 6 23.8096)",
    fill: "#FCCDB3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 17,
    height: 4.76191,
    rx: 2.38095,
    fill: "#FCCDB3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_307_4132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 25,
    transform: "matrix(-1 0 0 1 8 0)",
    fill: "#FA8443"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_307_4132)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4286,
    height: 4,
    rx: 2,
    transform: "matrix(0 -1 -1 0 10 23.8096)",
    fill: "#FA8443"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 4.76191,
    rx: 2.38095,
    transform: "matrix(-1 0 0 1 17 0)",
    fill: "#FA8443"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 7.95901e-10C37.4787 -2.05636e-05 36.9574 0.398465 36.7287 1.19546L31.1296 20.6158C30.8059 21.7442 31.1092 23.0787 31.8092 23.6013C31.9997 23.7418 32.1993 23.8093 32.3954 23.8093C32.9249 23.8093 33.4308 23.3259 33.6676 22.5028L34.3693 20.0596H38V15.5569H35.715L37.998 7.42854L38 7.43534V7.95901e-10Z",
    fill: "#FA8443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 0C38.5213 -1.51875e-07 39.0426 0.398486 39.2713 1.19546L44.8704 20.6158C45.1941 21.7442 44.8908 23.0787 44.1908 23.6013C44.0003 23.7418 43.8007 23.8093 43.6046 23.8093C43.0751 23.8093 42.5692 23.3259 42.3324 22.5028L41.6307 20.0596H38V15.5569H40.285L38.002 7.42854L38 7.4352V0Z",
    fill: "#FCCDB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1992 14.5206C21.441 14.5402 21.6858 14.5503 21.9332 14.5503C26.3882 14.5503 29.9997 11.2931 29.9997 7.27513C29.9997 3.25719 26.3882 0 21.9332 0C21.6858 0 21.441 0.0100463 21.1992 0.0297112V4.07225C21.5508 4.00423 21.9194 3.96805 22.2993 3.96805C24.7293 3.96805 26.6992 5.44859 26.6992 7.27493C26.6992 9.10126 24.7293 10.5818 22.2993 10.5818C21.9194 10.5818 21.5508 10.5456 21.1992 10.4776V14.5206Z",
    fill: "#FCCDB3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23.8096,
    width: 23.8095,
    height: 4.39993,
    rx: 2.19997,
    transform: "rotate(-90 19 23.8096)",
    fill: "#FCCDB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2001 5.96629e-09C21.2001 1.98997e-09 21.2 0 21.2 0C19.985 0 19 0.984958 19 2.19997V21.6096C19 22.8246 19.985 23.8095 21.2 23.8095C21.2042 23.8095 21.2085 23.8095 21.2127 23.8095H21.2001V5.96629e-09Z",
    fill: "#FA8443"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluate);
export default __webpack_public_path__ + "static/media/evaluate.9a23bc311ff36790b556f5da9f8a8e88.svg";
export { ForwardRef as ReactComponent };